import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  CardFooter,
  Row,
  Col,
} from "reactstrap";

// Icon
import { IoBriefcaseOutline } from "react-icons/io5";
import { MdOutlineMailOutline } from "react-icons/md";
import { TiContacts } from "react-icons/ti";
import { LuClipboardList } from "react-icons/lu";

const styleCard = {
  borderRadius: "1rem",
};

const styleIcon = {
  container: {
    height: "50px",
    width: "50px",
    backgroundColor: "rgba(255, 236, 232, 1)", // Light pink background
    borderRadius: "8px",
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    color: "rgba(255, 107, 92, 1)", // Icon color
    fontSize: "24px", // Icon size
    fontWeight: "bold", // Make the icon bold
  },
};

const coldEmails = 33;
const followUps = 25;
const leads = 12;
const trials = 1;

const ColdEmail = () => {
  return (
    <>
      <Card style={styleCard}>
        <CardBody>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={styleIcon.container}>
              <MdOutlineMailOutline color="rgba(255, 107, 92, 1)" size={22} />
            </div>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <span
                style={{ fontSize: "22px", fontWeight: "bold", color: "black" }}
              >
                {coldEmails} Mails
              </span>
            </div>
          </div>
          <CardText>
            <br />
            Cold Emails last week
            <br />
          </CardText>
        </CardBody>
      </Card>
    </>
  );
};

const FollowUps = () => {
  return (
    <>
      <Card style={styleCard}>
        {/* <CardTitle>Follow-ups
              <IoBriefcaseOutline/></CardTitle> */}
        <CardBody>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                ...styleIcon.container,
                backgroundColor: "rgba(238, 244, 255, 0.6)",
              }}
            >
              <IoBriefcaseOutline color="rgba(100, 141, 255, 1)" size={22} />
            </div>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <span
                style={{ fontSize: "22px", fontWeight: "bold", color: "black"}}
              >
                {followUps} Follow
              </span>
            </div>
          </div>
          <br />
          <CardText>
            Follow-ups last week
            <br />
          </CardText>
        </CardBody>
      </Card>
    </>
  );
};

const Leads = () => {
  return (
    <>
      <Card style={styleCard}>
        <CardBody>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                ...styleIcon.container,
                backgroundColor: "rgba(231, 248, 238, 0.6)",
              }}
            >
              <TiContacts color="rgba(77, 189, 138, 1)" size={22} />
            </div>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <span
                style={{ fontSize: "22px", fontWeight: "bold", color: "black" }}
              >
                {leads} Leads 
              </span>
            </div>
          </div>
          <br />
          <CardText>
            Leads last week
            <br />
          </CardText>
        </CardBody>
      </Card>
    </>
  );
};

const Trials = () => {
  return (
    <>
      <Card style={styleCard}>
        <CardBody>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                ...styleIcon.container,
                backgroundColor: "rgba(255, 246, 232, 1)",
              }}
            >
              <LuClipboardList color="rgba(253, 191, 101, 1)" size={22} />
            </div>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <span
                style={{ fontSize: "22px", fontWeight: "bold", color: "black" }}
              >
                {trials} Trial
              </span>
            </div>
          </div>
          <br />
          <CardText>
            Ongoing Trials last week
            <br />
          </CardText>
        </CardBody>
      </Card>
    </>
  );
};

const ContentHeader = () => {
  return (
    <>
      <div>
        <Row>
          <Col sm={3} lg={3}>
            <ColdEmail />
          </Col>
          <Col sm={3} lg={3}>
            <FollowUps />
          </Col>
          <Col sm={3} lg={3}>
            <Leads />
          </Col>
          <Col sm={3} lg={3}>
            <Trials />
          </Col>
        </Row>
      </div>

      {/* <div>
        <Row>
          <Col xs={6} md={6} lg={6}>
            <ColdEmail />
          </Col>
          <Col xs={6} md={6} lg={6}>
            <FollowUps />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={6} lg={6}>
            <Leads />
          </Col>
          <Col xs={6} md={6} lg={6}>
            <Trials />
          </Col>
        </Row>
      </div> */}
    </>
  );
};

export default ContentHeader;
